<po-container p-title="Inclusão de Orçamento">
  <form #formOrcamento="ngForm">
    <po-divider p-label="Dados"> </po-divider>
    <div class="po-row">
      <po-input class="po-md-4" name="status" [(ngModel)]="status" p-clean p-label="Situação" p-disabled="true">
      </po-input>

      <po-datepicker class="po-md-4" name="emissao" [(ngModel)]="emissao" p-clean p-label="Emissão" p-disabled="true">
      </po-datepicker>

      <po-select [p-disabled]="importacaoService.estaImportando()" class="po-md-3" name="condPg" [(ngModel)]="CondpgSelect" p-icon="po-icon po-icon-search"
        p-label="Condição de Pagamento" [p-help]="pohelp" p-required p-sort p-filter-mode="contains"
        [p-options]="condPgOptions" (p-change)="attHelp()">
      </po-select>
    </div>

    <po-divider p-label="Itens do orçamento"></po-divider>

    <div>
      <po-input [p-readonly]="importacaoService.estaImportando()" [(ngModel)]="produtoTemp" [p-minlength]="length" [p-maxlength]="length"
        [p-error-pattern]="'Tamanho do campo inválido'" class="po-xl-2 po-lg-2 po-md-2 po-sm-8" name="codProd"
        p-label="Cód. Produto"> </po-input>
      <po-input [p-readonly]="importacaoService.estaImportando()" class="po-xl-2 po-lg-2 po-md-2 po-sm-8" name="qtdProd"
        p-label="Quantidade" p-type="number" p-min="0.01" p-pattern="^([1-9]\d*(\.\d+)?)|([0]\.\d*[1-9]\d*)$"
        p-error-pattern="Digite um número maior que zero" [(ngModel)]="quantidadeTemp" #qtdProd="ngModel">
      </po-input>
    </div>

    <div class="po-row ">

      <po-button class="po-xl-2 po-lg-2 po-md-2 po-sm-8" p-label="Pesquisar Item" (p-click)="addItem()"
        p-icon="po-icon an an-file-magnifying-glass" p-type="primary"
        [p-disabled]="!CondpgSelect || qtdProd.invalid || importacaoService.estaImportando()">
      </po-button>

      <po-button class="po-xl-2 po-lg-2 po-md-2 po-sm-8" p-label="Add Item" (p-click)="addItemFromHome()"
        p-icon="po-icon an an-shopping-cart" p-type="primary"
        [p-disabled]="!CondpgSelect || qtdProd.invalid || importacaoService.estaImportando()">
      </po-button>

      <!-- Botão que dispara o input de arquivo ao ser clicado -->
      <po-button class="po-xl-2 po-lg-2 po-md-2 po-sm-8" p-label="Importar Planilha" (p-click)="onUploadCsv()"
        p-icon="po-icon an an-file-csv" [p-disabled]="!CondpgSelect || qtdProd.invalid || importacaoService.estaImportando()">
      </po-button>

      <po-button  (p-click)="onBaixarModelo()"
        p-tooltip="Baixa modelo de planilha para ser usado na função 'Importar Planilha'" p-icon="po-icon an an-file-csv" [p-disabled]="qtdProd.invalid || importacaoService.estaImportando()">
      </po-button>

      <po-progress *ngIf="importacaoService.estaImportando()" class="po-md-9" p-text="Importando Produtos..." [p-value]="importacaoService.progressBarValue"
        [p-show-percentage]="true">
      </po-progress>

      <!-- Input de arquivo escondido para selecionar o CSV -->
      <input #csvInput type="file" accept=".csv" style="display: none" (change)="onFileSelected($event)">

    </div>

    <div class="po-mt-5" *ngIf="items.length > 0">
      <po-table p-hide-columns-manager [p-columns]="columns" [p-items]="items" p-sort="true" [p-striped]="true"
        [p-actions]="actions">
      </po-table>
    </div>

    <po-divider p-label=""> </po-divider>
    <div class="po-row">
      <po-textarea class="po-md-8" name="observacao" [(ngModel)]="observacao" p-maxlength="250" p-label="Observações">
      </po-textarea>
    </div>

    <po-divider p-label=""> </po-divider>
    <po-divider p-label="Totais"> </po-divider>

    <div class="po-row">
      <po-decimal class="po-md-6 po-lg-3" name="subTotal" [(ngModel)]="subTotal" p-label="Total" p-disabled>
      </po-decimal>

      <po-decimal class="po-md-6 po-lg-3" name="Total" [(ngModel)]="total" p-label="Total + Impostos " p-disabled>
      </po-decimal>

      <po-decimal class="po-md-6 po-lg-3" name="QtdTotal" [(ngModel)]="qtdTotal" p-label="Total Quantidade" p-disabled>
      </po-decimal>
    </div>

    <po-divider p-label="  "> </po-divider>
    <div class="po-row" style="text-align: center">
      <po-button class="po-md-6" p-label="Salvar" (p-click)="salvaOrcamento()" p-type="primary"
        p-icon="po-icon po-icon-sale" [p-disabled]="!CondpgSelect  || importacaoService.estaImportando()">
      </po-button>
    </div>
  </form>
  <po-loading-overlay p-screen-lock="true" [hidden]="isHideLoading" p-text="Carregando...">
  </po-loading-overlay>
</po-container>

<po-modal p-click-out="false" p-hide-close="true" [p-primary-action]="confirm" p-size="800" p-title="Produtos">
  <form #ProdutoForm="ngForm">
    <po-input name="filtro" p-label="Buscar produtos" [(ngModel)]="produtoFiltro"
      p-placeholder="Informe um produto ou parte da descrição" p-icon="po-icon po-icon-search">
    </po-input>
    <po-radio-group p-columns="3" name="tpconsulta" [(ngModel)]="tpconsulta" p-label="Consulta por:"
      [p-options]="BuscaOptions">
    </po-radio-group>
    <po-button class="po-row form-produto-lista" p-label="Buscar" (p-click)="BuscaProduto()">
    </po-button>
    <po-table p-hide-columns-manager p-container="border" p-height="410" p-hide-select-all="true" p-sort="true"
      p-striped="true" p-hide-columns-manager [p-columns]="produtoColumns" [p-items]="produtoItems"
      [p-actions]="actionsProdutos" p-auto-collapse>
    </po-table>
  </form>
</po-modal>

<po-modal #AddProduto p-click-out="false" p-hide-close="true" p-size="100" p-title="Adicionar produto"
  [p-primary-action]="AddProdutoBotao" [p-secondary-action]="closeModalAlterar">
  <po-input name="codigo" p-label="Código/Descrição" p-icon="po-icon po-icon-stock" p-disabled="true"
    [(ngModel)]="produtoSelect">
  </po-input>
  <po-input *ngIf="!isPecas" name="especif" p-label="Descrição especifica" p-icon="po-icon po-icon-stock"
    p-disabled="true" [(ngModel)]="produtoEspecif">
  </po-input>
  <po-number class="po-md-6" name="quantidade" p-help="informe a quantidade desejada" p-label="Quantidade"
    p-placeholder="informe a quantidade" p-clean="true" p-no-autocomplete="true" [(ngModel)]="quantidade">
  </po-number>
  <po-number class="po-md-6" name="saldoestoque" p-disabled="true" p-placeholder="Consulte a área comercial"
    p-help="saldo sujeito à alteração sem aviso prévio" p-label="Saldo em estoque" [(ngModel)]="saldoEstoque">
  </po-number>
  <po-container>
    <po-button p-icon="po-icon po-icon-plus-circle" (p-click)="addQtdProdutos()">
    </po-button>
    <po-button p-icon="po-icon po-icon-minus-circle" (p-click)="rmQtdProdutos()">
    </po-button>
  </po-container>
  <po-container *ngIf="isPecas" p-height="200" p-no-border="true" class="po-m-5">
    <div class="po-font-text-bold">Produtos similares</div>

    <po-divider></po-divider>
    <po-table p-hide-columns-manager p-sort="true" p-auto-collapse [p-columns]="columnsSimilar" [p-items]="itemsSimilar"
      [p-striped]="true"></po-table>
  </po-container>
</po-modal>

<po-modal #AlteraProduto p-click-out="false" p-hide-close="true" p-size="100" p-title="Alterar quantidade"
  [p-primary-action]="AlteraProdutoBotao">
  <po-input name="codigo" p-label="Código/Descrição" p-icon="po-icon po-icon-stock" p-disabled="true"
    [(ngModel)]="produtoSelect">
  </po-input>
  <po-input *ngIf="!isPecas" name="especif" p-label="Descrição especifica" p-icon="po-icon po-icon-stock"
    p-disabled="true" [(ngModel)]="produtoEspecif">
  </po-input>
  <po-number class="po-md-6" name="quantidade" p-label="Quantidade" p-help="informe a quantidade desejada"
    p-placeholder="informe a quantidade" p-clean="true" p-no-autocomplete="true" [(ngModel)]="quantidade">
  </po-number>
  <po-number class="po-md-6" name="saldoestoque" p-disabled="true" p-placeholder="Consulte a área comercial"
    p-help="saldo sujeito à alteração sem aviso prévio" p-label="Saldo em estoque" [(ngModel)]="saldoEstoque">
  </po-number>
  <po-container>
    <po-button p-icon="po-icon po-icon-plus-circle" (p-click)="addQtdProdutos()">
    </po-button>
    <po-button p-icon="po-icon po-icon-minus-circle" (p-click)="rmQtdProdutos()">
    </po-button>
  </po-container>
  <po-container *ngIf="isPecas" p-height="200" p-no-border="true" class="po-m-5">
    <div class="po-font-text-bold">Produtos similares</div>

    <po-divider></po-divider>
    <po-table p-hide-columns-manager p-sort="true" p-auto-collapse [p-columns]="columnsSimilar" [p-items]="itemsSimilar"
      [p-striped]="true"></po-table>
  </po-container>
</po-modal>
<po-loading-overlay p-screen-lock="true" [hidden]="isHideLoading" p-text="Carregando...">
</po-loading-overlay>